module.exports = __webpack_public_path__ + "static/media/paymentEditIcon.17a4edb3.svg";